<template>
	<v-card class="pa-4" color="grey lighten-5" elevation="0">
		<v-card class="mb-2" dark color="blue darken-4">
			<v-container fluid>
				<v-row dense>
					<v-col :cols="12" lg="6" md="6" sm="6" xs="12">
						<div class="overline">Check In:</div>
						<div>
							<data-string
								:value="value.createdAt"
								dateFormat="dddd, MMMM Do YYYY, h:mm:ss a" 
								:flipDates="true"
							/>
						</div>
						<div>
							<router-link :to="tools.linkToDetail({ namespace: 'dist', pluralName: 'distributions', id: value.distribution.id })">
								<data-string :value="value.distribution.distributionCode" />
							</router-link>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
		<v-card class="mb-2">
			<v-container fluid>
				<v-row dense>
					<v-col :cols="12" lg="6" md="6" sm="6" xs="12">
						<div class="overline">Client:</div>
						<div class="caption">
							<router-link :to="tools.linkToDetail({ namespace: 'people', pluralName: 'clients', id: value.client.id })">
								<data-string :value="value.client.clientCode" />
							</router-link>
						</div>
						<div>
							<data-string :value="value.client.summary" />
						</div>
						<div>
							<data-string :value="value.client.emailAddress" />
						</div>
						<div>
							<data-string :value="value.client.phoneNumber" />
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
		<v-card class="mb-2" :loading="loaders.getEnrollments">
			<div class="pa-2">
				<div class="mb-2">Enrollment:</div>
				<v-card
					class="pa-2"
					v-for="enrollment in enrollments"
					:key="enrollment.id"
					dark
					color="blue-grey darken-2"
				>
					{{moment(enrollment.createdAt).format('YYYY')}} School Year
				</v-card>
				<v-alert v-if="enrollments.length === 0 && loaders.enrollmentLoaded" type="info" outlined dense>No enrollment found.</v-alert>
			</div>
		</v-card>
		<v-card class="mb-2" :loading="loaders.getMappers">
			<div class="pa-2">
				<div class="mb-2">Cards Mapped:</div>
				<v-card
					class="pa-2 mb-2"
					v-for="mapper in mappers"
					:key="mapper.id"
					color="light-blue lighten-5"
				>
					<div>
						Card Code:
						<router-link :to="tools.linkToDetail({ namespace: 'people', pluralName: 'mappers', id: mapper.id })">{{mapper.cardCode}}</router-link>
					</div>
					<div class="caption">Mapped on {{moment(mapper.createdAt).format("dddd, MMMM Do YYYY, h:mm:ss a")}}</div>
				</v-card>
				<v-alert v-if="mappers.length === 0 && loaders.mappersLoaded" type="info" outlined dense>No mapped cards found.</v-alert>
			</div>
		</v-card>
		
	</v-card>
</template>

<script>
import apiService from '@/apiService';
import tools from '@/tools';
import moment from 'moment';
import DataString from '@/components/pieces/DataString';
import DataInteger from '@/components/pieces/DataInteger';
export default {
	components: {
		DataString,
		DataInteger
	},
	props: {
		routeInfo: {
			type: Object
		},
		value: {
			type: Object
		},
		isBase: {
			type: Boolean,
			default: true
		},
		headerColor: {
			type: String,
			default: 'primary'
		}
	},
	data() {
		return {
			loaders: {
				getCheckins: false,
				getEnrollments: false
			},
			mappers: [],
			enrollments: [],
			moment,
			tools
		}
	},
	computed: {
	},
	methods: {
		getMappers() {
			this.loaders.getMappers = true;
			apiService.list({
				namespace: 'people',
				pluralName: 'mappers',
				filters: {
					client: {
						clientCode: this.value.client.clientCode
					}
				}
			}, (err, response) => {
				this.loaders.getMappers = false;
				this.loaders.mappersLoaded = true;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err.message
					});
					return;
				}
				this.mappers = response;
			});
		},
		getEnrollments() {
			this.loaders.getEnrollments = true;
			apiService.list({
				namespace: 'people',
				pluralName: 'enrollments',
				filters: {
					client: {
						clientCode: this.value.client.clientCode
					}
				}
			}, (err, response) => {
				this.loaders.getEnrollments = false;
				this.loaders.enrollmentLoaded = true;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err.message
					});
					return;
				}
				this.enrollments = response;
			});
		},
	},
	created() {
		this.getEnrollments();
		this.getMappers();
	},
	activated() {
		this.getEnrollments();
		this.getMappers();
	}
}
</script>